import React, { useCallback } from 'react';
import ReactCardFlip from 'react-card-flip';
import { VenueAnalysisData } from 'widgets/venueAnalysis/venueAnalysisAggregatedData';
import { VenueExecCapsuleContentFront } from './VenueExecCapsuleContentFront';
import { VenueExecCapsuleContentBack } from './VenueExecCapsuleContentBack';
import { VenueAnalysisCapsuleConfigState } from 'widgets/venueAnalysis/capsules/store/VenueAnalysisCapsuleConfigState';

interface VenueExecCapsuleContentProps {
    symbol?: string;
    capsuleKey: string;
    data?: VenueAnalysisData;
    showOrderData: boolean;
    config: VenueAnalysisCapsuleConfigState;
    dispatchConfigChanged: (
        configDelta: Partial<VenueAnalysisCapsuleConfigState>
    ) => void;
}
export function VenueExecCapsuleContent(props: VenueExecCapsuleContentProps) {
    const { data, config, dispatchConfigChanged, showOrderData } = props;
    const { view } = config;

    const isFlipped = view !== 'chart';

    const onBarClicked = useCallback(
        (view: 'back-historical' | 'back-today' | 'back-order') => {
            dispatchConfigChanged({ view });
        },
        [dispatchConfigChanged]
    );

    if (!data) {
        return <div className="VenueExecCapsuleContent">No data</div>;
    }

    const onBackClick = () => {
        dispatchConfigChanged({ view: 'chart' });
    };

    return (
        <div className="VenueExecCapsuleContent">
            <ReactCardFlip isFlipped={isFlipped} flipDirection={'vertical'}>
                <div>
                    <VenueExecCapsuleContentFront
                        data={data}
                        showOrderData={showOrderData}
                        onBarClicked={onBarClicked}
                    />
                </div>
                <div onClick={onBackClick}>
                    <VenueExecCapsuleContentBack
                        data={data}
                        view={view}
                        showOrderData={showOrderData}
                    />
                </div>
            </ReactCardFlip>
        </div>
    );
}
